import classnames from 'classnames'
import { useTranslation } from 'next-i18next'
import React from 'react'

import { SelectedFilter } from '../../domains/CollectionFilter'

import styles from './noProducts.module.scss'

interface NoProductProps {
  className?: string
  onResetFilters: (selectedFilters: SelectedFilter) => void
}

const NoProduct = (props: NoProductProps) => {
  const classes = classnames(styles.wrapper, props.className)
  const { t } = useTranslation()
  return (
    <div className={classes}>
      <div className={styles.header}>{t('no_product_found')}</div>
      <div className={styles.reset}>
        <u
          onClick={() => {
            props.onResetFilters(new SelectedFilter({}))
          }}
        >
          {t('reset_filter')}
        </u>
      </div>
    </div>
  )
}
export default NoProduct
